<template>
  <!--
    The visualiser used to display and edit only the motionDetectionArea of the videoDirectorConfigs.
  -->
  <div class="videoDirectorConfigMotionDetectionVisualiser">
    <svg
      ref="videDirectorConfigMotionDetectionVisualiserSvg"
      :viewBox="`0 0 ${ svgWidth } ${ svgHeight }`"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <circle
          id="point-handle-motionDetection"
          r="2.5"
          x="0"
          y="0"
          stroke-width="2.5"
          fill="white"
          fill-opacity="0.5"
          stroke="darkgray"
        />
      </defs>
      <Grid
        :width="svgWidth"
        :height="svgHeight"
        :columns="16"
        :rows="9"
        :center="false"
        :anchorIsCenter="false"
      />
      <template v-if="flowArea && flowArea.active && flowArea.initArea.motionDetectionArea.length">
        <polygon
          ref="videoDirectorConfigMotionDetectionAreaVisualiser"
          :points="createPolygon(flowArea.initArea.motionDetectionArea)"
          class="motionDetectionArea"
          stroke-linejoin="round"
        />
        <template v-if="edit">
          <use
            v-for="(point, motionIndex) in flowArea.initArea.motionDetectionArea"
            ref="videoDirectorConfigMotionDetectionVisualiserDragPoint"
            :key="`VideoDirectorConfigMotionDetectionVisualiser-flowArea-use-${ motionIndex }`"
            :x="point.x * quotientX"
            :y="point.y * quotientY"
            :motionindex="motionIndex"
            class="point-handle-motionDetection"
            href="#point-handle-motionDetection"
          />
        </template>
      </template>
      <slot />
    </svg>
  </div>
</template>

<script>
import interact from 'interactjs';

export default {
  name: "VideoDirectorConfigMotionDetectionVisualiser",
  components: {
    Grid: () => import('@/components/Config/VideoDirector/Visualiser/Svg/Grid.vue')
  },
  props: {
    flowArea: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    edit: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      }
    }
  },
  data () {
    return {
      svgWidth: 160,
      svgHeight: 90,
      scale: { x: 1, y: 1 }
    }
  },
  computed: {
    quotientX: function () {
      return this.svgWidth / 100;
    },
    quotientY: function () {
      return this.svgHeight / 100;
    }
  },
  mounted () {
    window.addEventListener("resize", this.updateScale);
    this.addDraggable();

    setTimeout(this.updateScale, 500);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.updateScale);
    this.removeDraggable();
  }, 
  methods: {
    update () {
      this.$nextTick(() => {
        this.removeDraggable();
        this.addDraggable();
      });
    },
    addDraggable () {
      if (!this.edit) {
        return;
      }

      if (!this.$refs.videoDirectorConfigMotionDetectionVisualiserDragPoint) {
        return;
      }

      this.$refs.videoDirectorConfigMotionDetectionVisualiserDragPoint.forEach(o => {
        interact(o, { context: document })
          .draggable({ max: Infinity, restrict: { restriction: 'svg', elementRect: { top: 0, left: 0, bottom: 1, right: 1 } },
            onmove: (event) => {
              let index = event.target.attributes.motionindex.value;
              this.flowArea.initArea.motionDetectionArea[index].x += event.dx * this.scale.x / this.quotientX;
              this.flowArea.initArea.motionDetectionArea[index].y += event.dy * this.scale.y / this.quotientY;

              this.flowArea.initArea.motionDetectionArea[index].x = this.round(this.flowArea.initArea.motionDetectionArea[index].x);
              this.flowArea.initArea.motionDetectionArea[index].y = this.round(this.flowArea.initArea.motionDetectionArea[index].y);
            }
        });
      });
    },
    removeDraggable () {
      if (this.$refs.videoDirectorConfigMotionDetectionVisualiserDragPoint) {
        this.$refs.videoDirectorConfigMotionDetectionVisualiserDragPoint.forEach(o => {
          interact(o).unset();
        });
      }
    },
    round (number) {
      //Round values to 2 decimal digits
      return Math.round(number * 1e2) / 1e2;
    },
    roundTo (numberToRound, zeros) {
      return Math.round( numberToRound * Math.pow(10, zeros)) / Math.pow(10, zeros);
    },
    updateScale () {
      let rootRect = this.$refs.videDirectorConfigMotionDetectionVisualiserSvg.getBoundingClientRect();
      this.scale = {
        x: this.svgWidth / rootRect.width,
        y: this.svgHeight / rootRect.height
      };
    },
    createPolygon (array) {
      if (typeof array[0].x === 'undefined') {
        return '';
      }
      let result = ``;
      for (let index = 0; index < array.length; index++) {
        result = `${ result } ${ array[index].x * this.quotientX } ${ array[index].y * this.quotientY }`;
      }
      return result;
    }
  }
}
</script>

<style scoped>
svg {
  overflow: visible;
}
.motionDetectionArea {
  stroke: purple;
  stroke-width: 1pt;
  fill: none;
}
</style>
